import { ASSIGN_TAGS, TAGS, UNASSIGN_TAGS } from '@mm/api-routes';
import * as queryString from 'query-string';
import TagModel from '../model/TagModel';
import AuthenticatedController from './AuthenticatedController';

class TagsController extends AuthenticatedController {
  static getAll(
    facebookPageId: number,
    kinds?: ('otn' | 'regular' | 'service')[],
  ): Promise<TagModel[]> {
    const qs = queryString.stringify(
      { kind: kinds, facebook_page_id: facebookPageId },
      { arrayFormat: 'bracket' },
    );
    return super.get(`${TAGS}?${qs}`);
  }

  static create(
    name: string,
    facebookPageId: number,
    kind?: 'otn' | 'regular' | 'service',
  ): Promise<{ tag: TagModel }> {
    return super.post(TAGS, { name, facebook_page_id: facebookPageId, kind });
  }

  static deleteTag(
    name: string,
    facebookPageId: number,
    kind?: 'otn' | 'regular' | 'service',
  ): Promise<{ ok: boolean }> {
    return super.delete(TAGS, null, undefined, {
      name,
      kind,
      facebook_page_id: facebookPageId,
    });
  }

  static assign(
    name: string,
    facebookPageId: number,
    contactId: number,
  ): Promise<TagModel[]> {
    return super.post(ASSIGN_TAGS, {
      name,
      contact_id: contactId,
      facebook_page_id: facebookPageId,
    });
  }

  static unassign(
    name: string,
    kind: 'otn' | 'regular' | 'service' | undefined,
    facebookPageId: number,
    contactId: number,
  ): Promise<{ json: () => Promise<TagModel[]> }> {
    return super.delete(UNASSIGN_TAGS, {
      name,
      kind,
      contact_id: contactId,
      facebook_page_id: facebookPageId,
    });
  }
}

export default TagsController;
